import React from 'react';
import { Link } from 'react-router-dom';

const Impressum = () => {
  return (
    <div className="calculator-container" data-testid="impressum-page">
      <div className="calculator-card" style={{ maxWidth: '800px' }}>
        <img
          src="https://customer-assets.emergentagent.com/job_lead-wizard-5/artifacts/xohrqn39_Logo%20separatus%20vergleich.png"
          alt="separatus Vergleich"
          style={{ maxWidth: '250px', marginBottom: '2rem', display: 'block' }}
        />
        <h1 style={{ fontSize: '2rem', fontWeight: '700', color: '#1B5E20', marginBottom: '2rem' }}>Impressum</h1>
        
        <div style={{ lineHeight: '1.8', color: '#2E2E2E' }}>
          <h2 style={{ fontSize: '1.25rem', fontWeight: '600', marginTop: '2rem', marginBottom: '1rem' }}>Angaben gemäß § 5 TMG</h2>
          <p>
            separatus<br />
            Musterstrasse 123<br />
            8000 Zürich<br />
            Schweiz
          </p>

          <h2 style={{ fontSize: '1.25rem', fontWeight: '600', marginTop: '2rem', marginBottom: '1rem' }}>Kontakt</h2>
          <p>
            Telefon: <a href="tel:+41715522350" style={{ color: '#1B5E20' }}>+41 71 552 2350</a><br />
            E-Mail: <a href="mailto:office@separatus.ch" style={{ color: '#1B5E20' }}>office@separatus.ch</a>
          </p>

          <h2 style={{ fontSize: '1.25rem', fontWeight: '600', marginTop: '2rem', marginBottom: '1rem' }}>Haftungsausschluss</h2>
          <h3 style={{ fontSize: '1rem', fontWeight: '600', marginTop: '1rem' }}>Haftung für Inhalte</h3>
          <p>
            Die Inhalte unserer Seiten wurden mit größter Sorgfalt erstellt. Für die Richtigkeit, Vollständigkeit und Aktualität der Inhalte können wir jedoch keine Gewähr übernehmen.
          </p>

          <h3 style={{ fontSize: '1rem', fontWeight: '600', marginTop: '1rem' }}>Haftung für Links</h3>
          <p>
            Unser Angebot enthält Links zu externen Webseiten Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen.
          </p>
        </div>

        <div style={{ marginTop: '3rem', textAlign: 'center' }}>
          <Link to="/" className="btn-primary">
            Zur Startseite
          </Link>
        </div>
      </div>
      
      {/* Footer mit Logo und Kontaktdaten */}
      <footer style={{
        background: '#2E2E2E',
        color: 'white',
        padding: '2rem',
        marginTop: '2rem',
        width: '100%'
      }}>
        <div style={{ 
          display: 'flex', 
          justifyContent: 'space-between', 
          alignItems: 'center',
          maxWidth: '600px',
          margin: '0 auto 1.5rem auto',
          gap: '2rem',
          flexWrap: 'wrap'
        }}>
          {/* Linke Spalte - Logo */}
          <div>
            <img 
              src="https://customer-assets.emergentagent.com/job_lead-wizard-5/artifacts/reiotrun_Logo%20separatus%20vergleich%20weiss.png"
              alt="separatus Vergleich"
              style={{ height: '45px', objectFit: 'contain' }}
            />
          </div>
          
          {/* Rechte Spalte - Kontaktdaten */}
          <div style={{ textAlign: 'left' }}>
            <a href="tel:+41715522350" style={{ color: '#C8E6C9', textDecoration: 'none', display: 'block', marginBottom: '0.5rem' }}>
              ☎ +41 71 552 2350
            </a>
            <a href="mailto:office@separatus.ch" style={{ color: '#C8E6C9', textDecoration: 'none', display: 'block' }}>
              ✉ office@separatus.ch
            </a>
          </div>
        </div>
        
        {/* Copyright über beide Spalten */}
        <p style={{ fontSize: '0.85rem', color: '#999', margin: 0, textAlign: 'center' }}>
          © {new Date().getFullYear()} separatus. Alle Rechte vorbehalten.
        </p>
      </footer>
    </div>
  );
};

export default Impressum;
